/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Basic chart preview
 *  This is just a facade to Highcharts.Chart mostly.
 *
 *  @constructor
 *
 *  @param parent {domnode} - the node to attach the preview to
 *  @param attributes {object} - the settings
 *    > defaultChartOptions {object} - the default chart options
 */

import { isArr } from '../../core/highcharts-editor';
import { tooltipFormatter } from './../../core-ui/tooltip/highed.tooltip.helper.utils';

const htmlEntities = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>'
};

export function fixPlotLinesAndBands(customizedOptions) {
  if (!customizedOptions) return;
  let count = 0;

  ['xAxis', 'yAxis'].forEach((axisName) => {
    if (customizedOptions[axisName]) {
      let axis = isArr(customizedOptions[axisName]) ? customizedOptions[axisName][0] : customizedOptions[axisName];
      [...(axis.plotLines || []), ...(axis.plotBands || [])].forEach((prop) => {
        if (!prop.hasOwnProperty('id')) {
          prop.id = count;
          count++;
        }
      });
    }
  });
}

export function setGlobalLang(options) {
  if (options.lang) {
    Highcharts.setOptions({
      lang: options.lang
    });
  }
}

export function convertHTMLEntities(csv) {
  Object.keys(htmlEntities).forEach(function (ent) {
    csv = csv.replace(new RegExp(ent, 'g'), htmlEntities[ent]);
  });

  return csv;
}

export function loadTooltip(options) {
  if (!options) return;

  if (options.everviz && options.everviz.tooltip) {
    //We have an everviz based tooltip, we need to set up our helper function
    if (!options.tooltip) options.tooltip = {};
    options.tooltip.formatter = tooltipFormatter;
  }
}
